module.exports = "<symbol id=\"thebestco-uikit-svg-Left12\" viewBox=\"0 0 12 12\"><path d=\"M8 0L9.41 1.41L4.83 6L9.41 10.59L8 12L2 6L8 0Z\"/></symbol>";